import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { AnimationItem } from 'lottie-web'
import {
  AnimationOptions,
  BMCompleteEvent,
  BMCompleteLoopEvent,
} from 'ngx-lottie'

@Component({
  selector: 'basin-lottie-animation-player',
  templateUrl: './lottie-animation-player.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LottieAnimationPlayerComponent implements OnInit {
  @Input() height: string
  @Input() width: string
  @Input() path: string
  @Input() autoplay: boolean = true
  @Input() loop: boolean = true
  @Input() numberOfLoopsToRun: number
  @Input() playTrigger: boolean
  @Input() stopTrigger: boolean
  @Input() startAnimationOnHover: boolean = false
  @Input() onlyAnimateDuringHover: boolean = false
  @Input() stopAfterAllLoopsCompleted: boolean = false
  @Output() animationCreated = new EventEmitter()
  @Output() animationCompleted = new EventEmitter()
  options: AnimationOptions
  animationItem: AnimationItem
  allLoopsCompletedOnce: boolean = false

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
    this.options = {
      ...this.options,
      path: this.path,
      loop: this.numberOfLoopsToRun <= 1 ? false : this.loop,
      autoplay: this.onlyAnimateDuringHover ? false : this.autoplay,
    }
  }

  onAnimate(animationItem: AnimationItem): void {
    this.animationItem = animationItem
    this.animationCreated.emit(animationItem)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.playTrigger) {
      this.play()
    }
    if (this.stopTrigger) {
      this.stop()
    }
  }

  onLoopComplete(bMCompleteLoopEvent: BMCompleteLoopEvent): void {
    if (this.numberOfLoopsToRun === this.animationItem.playCount) {
      this.stop()
      this.allLoopsCompletedOnce = true
    }
  }

  onComplete(bMCompleteEvent: BMCompleteEvent): void {
    if (!this.loop) {
      this.stop()
    }
    this.allLoopsCompletedOnce = true
    this.animationCompleted.emit(bMCompleteEvent)
  }

  onMouseOver() {
    if (this.stopAfterAllLoopsCompleted && this.allLoopsCompletedOnce) {
      return
    }
    if (this.startAnimationOnHover || this.onlyAnimateDuringHover) {
      this.play()
    }
  }

  onMouseLeave() {
    if (this.onlyAnimateDuringHover) {
      this.stop()
    }
  }

  play(): void {
    this.ngZone.runOutsideAngular(() => {
      this.animationItem?.play()
    })
  }

  stop(): void {
    this.ngZone.runOutsideAngular(() => {
      this.animationItem?.stop()
    })
  }
}
